import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ResenaModalPageRoutingModule } from './resena-modal-routing.module';

import { ResenaModalPage } from './resena-modal.page';
import {ComponentsModule} from '../../components/components.module';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ComponentsModule,
        TranslateModule
    ],
  declarations: [ResenaModalPage]
})
export class ResenaModalPageModule {}
